export var demoConfig = {
  /** Namespaces that should be loaded for this page */
  i18nNamespaces: ['common', 'demo']
};